import clsx from 'clsx'
import React, {useRef} from 'react'
import Box from '@mui/material/Box'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import {htmlToText} from 'helpers/utils'

import useStyles from './styles'

export default function PreviewOpenQuestion ({context, question}) {

  const {translate, quizQuestions = {}} = context
  const classes = useStyles()
  const premiseText = question.premise.html || translate('missing-premise')
  const text = htmlToText(question.answer.html)
	
  return (
    <Box className={clsx(classes.root, "question", "true-or-false")}>
      <Box className={clsx(classes.premise, "premise")}>
        {premiseText && <div className="instructions" dangerouslySetInnerHTML={{__html: premiseText}} />}
      </Box>
      <Box className={clsx(classes.answer, "answer")}>
        <TextareaAutosize
          className={classes.textarea}
          maxRows={5}
          minRows={5}
          readOnly
          value={text}
        />
     </Box>
    </Box>
  );
}
